import curry from 'lodash.curry';

type TCurrencyOptions = {
  currency: string;
  [index: string]: string;
};

type TFormatters = {
  [index: string]: Intl.NumberFormat;
};

export const currencyFormatter = (locale: string) => {
  const formatters: TFormatters = {};
  return curry((currencyOptions: string | TCurrencyOptions, number: number | bigint) => {
    const currency = (currencyOptions as TCurrencyOptions).currency ?? currencyOptions;
    const noOptions = currencyOptions === currency;
    const formatOptions = noOptions
      ? { currency, style: 'currency' }
      : (currencyOptions as TCurrencyOptions);
    const saveFormatter = noOptions && formatters[currency] === undefined;
    const formatter: Intl.NumberFormat =
      (noOptions && formatters[currency]) || new Intl.NumberFormat(locale, formatOptions);
    if (saveFormatter) {
      formatters[currency] = formatter;
    }
    return formatter.format(number);
  });
};

export default {
  currencyFormatter,
};
